import React from "react";
import "jquery-ui-bundle";
import "jquery/dist/jquery.min.js";
import $ from "jquery";
import { msalAuth } from "../../../api/msal/MsalAuthProvider";
import MyContext from "../../../api/context/my-context";
import { GetTreeStructure, FAddfolder } from "../../common/common";

class AddFolderModal extends React.Component {
  constructor(props) {
    super(props);
    this.handleEvent = this.handleEvent.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.addfolder = this.addfolder.bind(this);

    this.state = {
      tabName: props.tabName,
      menuName: props.menuName,
      token: null,
      treeList: [],
      treeListUpdate: [],
      treekey: props.treekey,
      treeCount: 0,
      hiddenActive: true,
      folderName: "",
    };
  }
  handleEvent() {
    var tree = this.state.treeList;
    this.state = {
      tabName: this.props.tabName,
      menuName: this.props.menuName,
      token: this.state.token,
      treeList: tree,
      treeListUpdate: this.state.treeListUpdate,
      treekey: this.props.treekey,
      folderName: this.state.folderName,
      hiddenActive: this.state.hiddenActive,
    };
  }

  //test

  handleChange(event) {
    this.setState({ folderName: event.target.value });
    console.log(event.target.value);
  }
  handleToggle = () => {
    var parentFolder = document.getElementById("tree-parent-id").value;
    var parentFolderName = ""; //document.getElementById("tree-parent-name").value;
    var parent = document.getElementsByClassName("open");
    if (parent.length > 0) {
      parentFolderName = parent[parent.length - 1].textContent;
    }
    if (parentFolder) {
      this.setState({
        hiddenActive: !this.state.hiddenActive,
        folderName: parentFolderName,
      });
    }
  };
  handleToggleClose = () => {
    this.setState({
      hiddenActive: !this.state.hiddenActive,
    });
  };

  list = [];
  allTree = {
    treeList: [],
    treecount: null,
  };
  model = {
    content: [
      {
        key: "algemeen-isvoor",
        and_or: "AND",
        values: [this.props.treekey],
        datatype: "STRING",
      },
    ],
    context: [],
    timestamps: [],
    definitions: [process.env.REACT_APP_TREE],
    statuses: [],
  };

  list_to_tree(list) {
    var map = {},
      node,
      roots = [],
      i;
    for (i = 0; i < list.length; i += 1) {
      map[list[i].id] = i;
      list[i].children = [];
    }
    for (i = 0; i < list.length; i += 1) {
      node = list[i];
      if (node.parentfolder !== "0" && node.parentfolder !== undefined) {
        list[map[node.parentfolder]].children.push(node);
      } else {
        roots.push(node);
      }
    }
    return roots;
  }
  sleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time));
  }
  GetTreeStructure(model, isUpdate) {
    var that = this;
    $.ajax({
      type: "POST",
      url:
        "https://" +
        process.env.REACT_APP_BASE_URL +
        "/omnimap/search/?page-size=1000&page-number=1&includes=PROPERTIES,MONITORING,CONTENT,CONTEXT",
      beforeSend: function (request) {
        request.setRequestHeader("Authorization", "Bearer " + window.localStorage.getItem("accessToken"));
        request.setRequestHeader(
          "tenant_identification",
          process.env.REACT_APP_TENANT_IDENTIFICATION
        );
        request.setRequestHeader(
          "organisation_identification",
          process.env.REACT_APP_ORGANISATION_IDENTIFICATION
        );
      },
      contentType: "application/json",
      dataType: "json",
      data: JSON.stringify(model),
      success: function (result) {
        var data = result.data;
        if (data != undefined) {
          console.log(data);
          that.list = [];
          for (let i = 0; i < data.length; i++) {
            that.list.push({
              name: data[i].name,
              id: data[i].identification,
              isSubfolder: data[i].content["algemeen-issubfolder"],
              parentfolder: data[i].content["algemeen-parentfolder"],
              children: null,
            });
          }

          if (!isUpdate) {
            // var result = list_to_tree(list, 0);
            that.setState({ treeList: [] });
            that.setState({ treeList: that.list_to_tree(that.list, 0) });
          } else {
            that.allTree.treeList = that.list_to_tree(that.list, 0);
            that.allTree.treecount = that.list.length;
          }
        }
      },
      error: function (err) {
        console.log("errror");
      },
    });
  }

  addfolder() {
    var that = this;
    if (that.state.folderName) {
      $("#cover-spin").show(0);
      var parent = document.getElementById("tree-parent-id").value;
      var model =
        parent != ""
          ? {
              relationships: { definition: { code: "FOLDER" } },
              name: that.state.folderName,
              content: {
                algemeen: {
                  issubfolder: true,
                  actief: true,
                  isvoor:
                    that.state.treekey.toString().charAt(0).toUpperCase() +
                    that.state.treekey.toString().slice(1),
                  parentfolder: parent,
                },
              },
            }
          : {
              relationships: { definition: { code: "FOLDER" } },
              name: that.state.folderName,
              content: {
                algemeen: {
                  issubfolder: false,
                  actief: true,
                  isvoor:
                    that.state.treekey.toString().charAt(0).toUpperCase() +
                    that.state.treekey.toString().slice(1),
                },
              },
            };
      FAddfolder(model, that.state.token).then(function (result) {
        if (result) {
          that.sleep(800).then(() => {
            GetTreeStructure("", that.model, that.state.token, true).then(
              function (TreeResult) {
                if (TreeResult) {
                  that.allTree.treeList = TreeResult.treeList;
                  that.allTree.treecount = TreeResult.treecount;
                  $("#treeButton-add-folder").click();
                  that.setState({ folderName: "" });
                  $("#cover-spin").hide(0);
                }
              }
            );
          });
        }
      });
    } else alert("please write folder name");
  }

  /*****BEGIN ---REACT LIFE CICYLE FUNCTIONS--- BEGIN*****/
  componentDidUpdate(prevProps, prevState) {
    var that = this;
    if (prevProps.treekey != that.state.treekey) {
      that.model.content[0].values[0] = that.state.treekey;
      that.GetTreeStructure(that.model);
    }
  }
  async componentDidMount() {
    var that = this;
    try {
      const accessTokenRequest = {
        scopes: ["user.read", "openid", "profile"],
      };
      var accessToken = null;
      try {
        accessToken = await msalAuth
          .acquireTokenSilent(accessTokenRequest)
          .then((response) => {
            // token = response.idToken.rawIdToken;
            that.setState({ token: response.idToken.rawIdToken });
          });
      } catch (error) {
        console.log("AquireTokenSilent failure");
        console.log(error);
        accessToken = await msalAuth
          .acquireTokenPopup(accessTokenRequest)
          .then((response) => {
            // get access token from response
            // response.accessToken
            // token = response.idToken.rawIdToken;
            that.setState({ token: response.idToken.rawIdToken });
          })
          .catch((err) => {
            // handle error
            console.log(err);
          });
      }
    } catch (err) {
      var error = {};
      if (typeof err === "string") {
        var errParts = err.split("|");
        error =
          errParts.length > 1
            ? { message: errParts[1], debug: errParts[0] }
            : { message: err };
      } else {
        error = {
          message: err.message,
          debug: JSON.stringify(err),
        };
      }

      this.setState({
        user: {},
        isLoading: false,
        error: error,
        treeList: null,
      });
    }

    $(document).on("click", "#map_aanmaken", function () {
      $("#mappen_folder_add_modal").modal("show");
    });
  }
  /*****END ---REACT LIFE CICYLE FUNCTIONS--- END*****/
  render() {
    this.handleEvent();
    return (
      <div
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        id="mappen_folder_add_modal"
      >
        {" "}
        <MyContext.Consumer>
          {(context) => (
            <div hidden>
              <button
                id="treeButton-add-folder"
                onClick={() => context.actions.addTask(this.allTree)}
              >
                + add
              </button>
            </div>
          )}
        </MyContext.Consumer>
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Nieuwe Map aanmaken</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div id="delete-side">
                <div className="delete-side-div">
                  <div className="fullwidth">
                    <input
                      id="map_x"
                      type="input"
                      className="form-control new folder"
                      placeholder="Naam van de map..."
                      autocomplete="off"
                      value={this.state.folderName}
                      onChange={this.handleChange}
                    />
                    <a
                      href="javascript:void(0)"
                      className="addfolder"
                      onClick={this.addfolder}
                    ></a>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer"></div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddFolderModal;
